import UserPassword from './UserPassword.vue';

export default UserPassword;
